import React from "react"
import { useSelector } from "react-redux"
import GuestHeader from "layoutsV2/client/GuestHeader"
import { ProHeaderUI } from "layoutsV2/pro/ProHeader/ProHeaderUI"

/**
 * Reusable Header Component for Embedded Pages
 *
 * Renders appropriate header based on user authentication and role:
 * - Guide users (logged in) → ProHeaderUI
 * - Guest/Client users (logged in) → GuestHeader
 * - Non-authenticated users → GuestHeader (public view)
 *
 * @example
 * <EmbeddedPageHeader />
 */
const EmbeddedPageHeader = () => {
  const userData = useSelector((state) => state.user)
  const accessToken = localStorage.getItem("access_token")

  // Guide user logged in - show ProHeaderUI
  if (userData?.role === "guide_user" && accessToken) {
    return <ProHeaderUI />
  }

  // All other cases (guest logged in, or not logged in) - show GuestHeader
  // GuestHeader handles its own logic for showing sign in/sign up vs user menu
  return <GuestHeader />
}

export default EmbeddedPageHeader
